"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const c = __importStar(require("./constants"));
const core = __importStar(require("@actions/core"));
const graalvm = __importStar(require("./graalvm"));
const path_1 = require("path");
const dependencies_1 = require("./dependencies");
const gu_1 = require("./gu");
const mandrel_1 = require("./mandrel");
const features_1 = require("./features");
const msvc_1 = require("./msvc");
function run() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const graalvmVersion = core.getInput('version', { required: true });
            const gdsToken = core.getInput('gds-token');
            const javaVersion = core.getInput('java-version', { required: true });
            const componentsString = core.getInput('components');
            const components = componentsString.length > 0 ? componentsString.split(',') : [];
            const setJavaHome = core.getInput('set-java-home') === 'true';
            const enableNativeImageMusl = core.getInput('native-image-musl') === 'true';
            if (c.IS_WINDOWS) {
                (0, msvc_1.setUpWindowsEnvironment)();
            }
            yield (0, dependencies_1.setUpDependencies)(components);
            if (enableNativeImageMusl) {
                yield (0, features_1.setUpNativeImageMusl)();
            }
            // Download or build GraalVM
            let graalVMHome;
            switch (graalvmVersion) {
                case c.VERSION_LATEST:
                    graalVMHome = yield graalvm.setUpGraalVMLatest(gdsToken, javaVersion);
                    break;
                case c.VERSION_DEV:
                    graalVMHome = yield graalvm.setUpGraalVMDevBuild(gdsToken, javaVersion);
                    break;
                default:
                    if (graalvmVersion.startsWith(c.MANDREL_NAMESPACE)) {
                        graalVMHome = yield (0, mandrel_1.setUpMandrel)(graalvmVersion, javaVersion);
                    }
                    else {
                        graalVMHome = yield graalvm.setUpGraalVMRelease(gdsToken, graalvmVersion, javaVersion);
                    }
                    break;
            }
            // Activate GraalVM
            core.debug(`Activating GraalVM located at '${graalVMHome}'...`);
            core.exportVariable('GRAALVM_HOME', graalVMHome);
            core.addPath((0, path_1.join)(graalVMHome, 'bin'));
            if (setJavaHome) {
                core.exportVariable('JAVA_HOME', graalVMHome);
            }
            // Set up GraalVM components (if any)
            if (components.length > 0) {
                if (graalvmVersion.startsWith(c.MANDREL_NAMESPACE)) {
                    core.warning(`Mandrel does not support GraalVM components: ${componentsString}`);
                }
                else {
                    yield (0, gu_1.setUpGUComponents)(gdsToken, graalVMHome, components);
                }
            }
        }
        catch (error) {
            if (error instanceof Error)
                core.setFailed(error.message);
        }
    });
}
run();
